import { AxiosRequestConfig, isAxiosError, Method } from "axios";
import { supportAxios } from "./axios-support.instance";

export class ApiSupportClient {
  private static async request<T>(
    method: Method,
    url: string,
    data?: unknown,
    config?: AxiosRequestConfig
  ): Promise<T> {
    try {
      const response = await supportAxios({
        method,
        url,
        data,
        ...config,
      });

      return response.data;
    } catch (error) {
      console.error(`API Error (${method} ${url}):`, error);

      if (isAxiosError(error) && error.response) {
        throw JSON.stringify(error.response.data.message);
      }

      throw new Error("An unexpected error occurred");
    }
  }

  public static async get<TResponse>(
    url: string,
    config?: AxiosRequestConfig
  ): Promise<TResponse> {
    return this.request<TResponse>("GET", url, undefined, config);
  }

  public static async post<TRequest, TResponse>(
    url: string,
    data?: TRequest,
    config?: AxiosRequestConfig
  ): Promise<TResponse> {
    return this.request<TResponse>("POST", url, data, config);
  }

  public static async put<TRequest, TResponse>(
    url: string,
    data?: TRequest,
    config?: AxiosRequestConfig
  ): Promise<TResponse> {
    return this.request<TResponse>("PUT", url, data, config);
  }

  public static async patch<TRequest, TResponse>(
    url: string,
    data?: TRequest,
    config?: AxiosRequestConfig
  ): Promise<TResponse> {
    return this.request<TResponse>("PATCH", url, data, config);
  }

  public static async delete<TResponse>(
    url: string,
    config?: AxiosRequestConfig
  ): Promise<TResponse> {
    return this.request<TResponse>("DELETE", url, undefined, config);
  }
}
